
import { SELECT_ACTIVITY_ID, INVALIDATE_ACTIVITY_ID,REQUEST_CPS, RECEIVE_CPS} from './actions'
import { CHECK_PERMISSIONS } from './actions'
import { GENERATE_ASSESSMENTS} from './actions'





/**
 * CPS
 * @param {*} state 
 * @param {*} action 
 */
export function selectedActivityId(state = '', action) {
  switch (action.type) {
    case SELECT_ACTIVITY_ID:
      return action.activityId
    default:
      return state
  }
}


function cps(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
    
    case INVALIDATE_ACTIVITY_ID:
      return Object.assign({}, state, {
        didInvalidate: true
      })
    case REQUEST_CPS:
      return Object.assign({}, state, {
        isFetching: true,
        didInvalidate: false
      })
    case RECEIVE_CPS:
      return Object.assign({}, state, {
        isFetching: false,
        didInvalidate: false,
        items: action.cps,
        lastUpdated: action.receivedAt
      })
    default:
      return state
  }
}

export function cpsByActivityId(state = {}, action) {
  switch (action.type) {
    case INVALIDATE_ACTIVITY_ID:
    case RECEIVE_CPS:
    case REQUEST_CPS:
      return Object.assign({}, state, {
        [action.activityId]: cps(state[action.activityId], action)
      })
    default:
      return state
  }
}

export function permissions(state = [],action) {
  switch (action.type) {
  case CHECK_PERMISSIONS:
    return action.permissions
  default:
    return state
  }
}


export function adminState(state=[],action) {
  switch (action.type) {
    case GENERATE_ASSESSMENTS:
      return action.assessments
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/admin/reducers.js